import { FaFacebookF } from "react-icons/fa";
import { FiShoppingCart } from "react-icons/fi";

export const socialMediaData = [
  {
    id: 1,
    icon: FaFacebookF,
    url: "https://www.facebook.com/profile.php?id=61589683220859",
    label: "Facebook",
  },
  {
    id: 2,
    icon: FiShoppingCart,
    url: "https://allegro.pl",
    label: "Allegro",
  },
];
